export enum ZIndex {
	Sidebar = 1000,
	ComposerBackdrop = 1100,
	Composer = 1101,
	UploadQueueOverlay = 1350, // Below Chakra Drawer (1400) so it doesn't interfere when drawer is open
	FileViewer = 1500,
	GlobalOverlayLoader = 9999,
}
